import React from "react";
import { useSelector } from "react-redux";
const ChatUser = ({ user, handleSelectChatRoom, setUserChatWith }) => {
  const { userInfo } = useSelector((state) => state.user);
  return (
    <a
      href="#"
      className="d-flex justify-content-between chat-member mb-3"
      onClick={(e) => {
        e.preventDefault();
        handleSelectChatRoom(user.id);
        setUserChatWith(user);
      }}
    >
      {console.log(user, "Chat")}
      <div className="d-flex align-items-center">
        <div className="avatar avatar-lg  flex-shrink-0 me-2">
          <img src={user.imageUrl} alt="User Image" />
        </div>
        <div>
          <h6 className="fs-16 fw-medium mb-1">{user.fullName}</h6>
          <p className="fs-14 text-gray-6 text-truncate">{user.email}</p>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="text-end-right">
          <p className="mb-1 fs-14 text-gray-6">
            {userInfo.checkStaff ? "Khách hàng" : "Nhân viên"}
          </p>
          <div className="d-flex justify-content-end">
            {/* <span className="msg-count badge badge-primary d-flex align-items-center justify-content-center rounded-circle">
              2
            </span> */}
          </div>
        </div>
      </div>
    </a>
  );
};

export default ChatUser;
